import { useWhitelabel } from "features/Account/modules/Whitelabel/utils/useWhitelabel";
import { useWAIntegration } from "../../WhatsappStepper/utils/useWAIntegration";
import { useEffect, useState } from "react";
import { useWAIntegrationStore } from "../../Whatsapp/store/useWAIntegrationStore";
import { whitelabelled_whatsapp_status_constants } from "../../WhatsappStepper/constants/WhatsappStepper.constants";

export const useWhatsappLinkingStatus = () => {
  const { isAccessible: isWhitelabelActive } = useWhitelabel();
  const { loading: whatsappLoading } = useWAIntegration();

  const whatsappDetails = useWAIntegrationStore((store) => store.details);

  const [isWhatsappLinked, setIsWhatsappLinked] = useState(false);
  const [showLock, setShowLock] = useState(false);
  const [showLink, setShowLink] = useState(false);

  useEffect(() => {
    if (!whatsappLoading) {
      setIsWhatsappLinked(
        whatsappDetails?.whitelabelled_whatsapp_status ===
          whitelabelled_whatsapp_status_constants.CONNECTED
      );
    }
  }, [whatsappLoading, whatsappDetails]);

  return {
    isWhitelabelActive,
    whatsappLoading,
    isWhatsappLinked,
    showLock,
    setShowLock,
    showLink,
    setShowLink,
    whatsappDetails,
  };
};
